import React, { useEffect, useState } from 'react';
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import TableBody from "@mui/material/TableBody";
import IconButton from "@mui/material/IconButton";
import { CheckBox, HighlightOff } from "@mui/icons-material";
import { useController, useFieldArray, useFormContext } from "react-hook-form";
import { Button, CircularProgress, Dialog, DialogContent, Divider, FormHelperText } from "@mui/material";
import DialogTitle from "@mui/material/DialogTitle";
import DialogActions from "@mui/material/DialogActions";
import IndicatorCRUDTable from "../CRUD/Tables/IndicatorCRUDTable";
import { departmentCRUD, serviceGroupCRUD, serviceMapCRUD, serviceSubGroupCRUD } from '../../http';
import RestSelect from '../Select/RestSelect';
import { copy, distinct } from '../../functions/linqSimulation';
import LoadingContainer from '../Loader/LoadingContainer';
import { RHFCheckbox } from './RHFCheckbox';
import RestAutoComplete from '../Autocompletes/RestAutoComplete';
import useCache from '../../hooks/useCache';
import useLoader from "../../hooks/useLoader";
import { asJSONSafe } from '../../functions';

function RHFGroupIndicator({ label, name, disabled }) {
    const [loading2, setLoading2] = useState(false);
    const { control, watch, setValue } = useFormContext();
    const { fieldState: { error } } = useController({ name: name + '.indicators' });

    //const [groupId, setGroupId] = useState(null);
    const departmentId = watch(name + '.departmentId');
    const groupId = watch(name + '.groupId');
    console.log('groupId:' + groupId);
    const [serviceSubGroups, setServiceSubGroups] = useState(null);
    const [serviceSubGroupIds, setServiceSubGroupIds] = useState(null);
    const [loading, setLoading] = useState(false);
    const [departmentChanged, setDepartmentChanged] = useState(false);
    const [groupChanged, setGroupChanged] = useState(false);

    const [serviceMap, setServiceMap] = useState(null);

    const { getOrCreate } = useCache();

    const [query, setQuery] = useState({
        paging: { skip: 0, take: 0 }
    });
    const [departmentQuery, setDepartmentQuery] = useState({
        paging: { skip: 0 }, sort: {
          name: { operator: 'asc' }
        },
        filter: {
            isDeleted: {
                operand1: false,
                operator: 'equals'
            }
        }
    });
    const [groupQuery, setGroupQuery] = useState({
        paging: { skip: 0, take: 10000 }, sort: {
          name: { operator: 'asc' }
        }
    });

    const indicatorsName = name + '.indicators';

    const { fields, append, remove } = useFieldArray({
        control,
        name: indicatorsName,
    });

    const indicators = watch(indicatorsName, []);

    const fetchServiceMap = async () => {
        const request = {
            paging: { skip: 0 },
            filter: {
                groupId: {
                    operand1: groupId,
                    operator: 'equals'
                }
            }
        }

        if (departmentId) {
            request.filter.departmentId = {
                operand1: departmentId,
                operator: 'equals'
            }
        }

        //const response = await getOrCreate('serviceMap', request, async () => await serviceMapCRUD.search(request), 30);
        const response = await serviceMapCRUD.search(request);
        return response.result || [];
    }

    const fetchServiceMap2 = async () => {
        if (!departmentId)
            return;

        setLoading2(true);
        const request = {
            paging: { skip: 0 },
            filter: {
                departmentId: {
                    operand1: departmentId,
                    operator: 'equals'
                }
            }
        }

        //const response = await getOrCreate('serviceMap', request, async () => await serviceMapCRUD.search(request), 30);
        const response = await getOrCreate('serviceMap', request, async _ => await serviceMapCRUD.search(request), 30);
        setServiceMap(response?.result || []);   
        if (departmentChanged) {
            setValue(name + '.groupId', null);
        }
        setLoading2(false);
    }

    const fetchServiceSubGroup = async () => {
        if (serviceSubGroups) {
            return serviceSubGroups;
        }

        const request = {
            paging: { skip: 0 },
            // filter: {
            //     groupId: {
            //         operand1: groupId,
            //         operator: 'equals'
            //     }
            // },
            sort: {
                name: { operator: 'asc' }
              }
        };

        //const response2 = await getOrCreate('serviceSubGroup', request, async () => await serviceSubGroupCRUD.search(), 30);
        const response2 = await serviceSubGroupCRUD.search(request);
        return response2.result || [];
    }

    const fetch = async () => {
        setLoading(true);
        const serviceMaps = serviceMap ? [...serviceMap.filter(_ => _.groupId == groupId)] : await fetchServiceMap();
        const serviceSubGroupIds2 = distinct(serviceMaps.map(_ => _.subGroupId), (a, b) => a == b);
        setServiceSubGroupIds(serviceSubGroupIds2);

        const serviceSubGroups2 = await fetchServiceSubGroup();
        setServiceSubGroups(serviceSubGroups2);

        const data = serviceSubGroups2.filter(_ => serviceSubGroupIds2.find(i => i == _.id));

        remove();
        for (let i = 0; i < data.length; i++) {
            const item = data[i];
            item.groupId = groupId;
            item.checked = true;
        }

        append(data);

        setLoading(false);
    }

    const setSelectedForAll = (value) => {
        for (let i = 0; i < indicators.length; i++) {
            const item = indicators[i];
            item.checked = value;            
        }
        const newIndicators = copy(indicators);        
        remove();
        //append(newIndicators);
        setTimeout(() => append(newIndicators), 100);        
    }

    useEffect(() => {        
        if (departmentChanged) {
            remove();
        }
        if (!departmentId) {            
            setValue(name + '.groupId', null);
            return;        
        }        
        //setValue(name + '.groupId');        
        fetchServiceMap2();
    }, [departmentId, departmentChanged]);

    useEffect(() => {        
        if ((!departmentId && departmentChanged) || (!groupId && groupChanged)) {
            remove();
            return;        
        }
        //setValue(name + '.groupId');
        if (groupId && groupChanged)
            fetch();
    }, [groupId, groupChanged]);

    useEffect(() => {
        setGroupQuery({...groupQuery});
    }, [serviceMap]);

    const deleteColumnStyles = {
        position: "sticky",
        right: 0,
    },
        cellHeadStyles = { fontWeight: "bold" };

    function deleteActHandler(id) {
        const index = fields.findIndex(el => el.actId === id)
        remove(index);
    }

    const [open, setOpen] = useState(false)

    return (
        <table style={{ width: '100%' }}>
            <tr>
            <td>
            <Grid item xs={12}>                
                <Button size="small" sx={{ marginTop: '20px', marginLeft: "15px" }} onClick={() => setSelectedForAll(true)} disabled={disabled} variant={"contained"}>
                    Выбрать все
                </Button>
                <Button size="small" sx={{ marginTop: '20px', marginLeft: "15px" }} onClick={() => setSelectedForAll(false)} disabled={disabled} variant={"contained"}>
                    Снять выбор со всех
                </Button>
            </Grid>
            </td>
            </tr>
            <tr>
            <td>
            <Grid item xs={12} style={{ overflowX: "auto", paddingLeft: '15px' }}>
                <Typography color={"textSecondary"}>
                        {label || "Показатели"}
                    </Typography>
                </Grid>
            </td>
            </tr>
            {/* <Button size="large" sx={{ marginTop: '20px', marginLeft: "15px" }} onClick={() => setOpen(true)} disabled={disabled} variant={"contained"}>
                Выбрать показатели
            </Button> */}

            <tr>
            <td>
            <Divider />
            </td>
            </tr>

            <tr>
            <td>
            <Grid container spacing={1} style={{ paddingLeft: '15px' }}>
                <Grid item xs={3} style={{ overflowX: "auto", width: '100%' }}>
                    <RestAutoComplete
                        restApi={departmentCRUD}
                        onSearch={async (request, getFunc) => {
                            return await getOrCreate('department', request, getFunc, 30);
                        }}
                        displayEndAdornment={false}
                        query={departmentQuery}
                        id={"department"}
                        label={"Лаборатория"}
                        value={departmentId}
                        onChange={(value, obj) => {
                            //setGroupId(value?.id);
                            setValue(name + '.departmentId', value?.id);
                            setDepartmentChanged(true);
                            setGroupQuery({...groupQuery});
                        }}
                        //getOptionLabel={(_) => _.name}
                        fullWidth
                    />

                </Grid>
                <Grid item xs={3}>
                    {loading2 ? <CircularProgress/> :
                        <Grid container>
                            <Grid item>
                                <RestAutoComplete
                                    restApi={serviceGroupCRUD}
                                    onSearch={async (request, getFunc) => {                                        
                                        let response = await getOrCreate('serviceGroup', request, getFunc, 30);

                                        if (serviceMap) {                                                            
                                        response = {...response, result: [...response.result.filter(_ => serviceMap.find(i => i.groupId == _.id))]};
                                        }

                                        return response;
                                    }}
                                    query={groupQuery}
                                    id={"serviceGroup"}
                                    label={"Группа"}
                                    value={groupId}
                                    onChange={(value, obj) => {
                                        //setGroupId(value?.id);
                                        setGroupChanged(true);
                                        setValue(name + '.groupId', value?.id);
                                    }}
                                    disabled={!departmentId}
                                    style={{width: '600px'}}
                                    //getOptionLabel={(_) => _.name}
                                    fullWidth
                            />
                            </Grid>
                        </Grid>}
                </Grid>

            </Grid>
            <LoadingContainer loading={loading}>
                <Grid container spacing={1}>
                    <Grid item style={{ overflowX: "auto" }}>
                        <Table disabled={!departmentId || !groupId}>
                            <TableBody>
                                {(fields || []).map((item, index) => {
                                    return (
                                        <TableRow>
                                            <TableCell variant={"head"} style={cellHeadStyles}>
                                                {item.name}
                                            </TableCell>
                                            <TableCell align={"right"} style={deleteColumnStyles}>
                                                <RHFCheckbox name={name + `.indicators[${index}].checked`} ></RHFCheckbox>
                                            </TableCell>
                                        </TableRow>
                                    );
                                })}
                            </TableBody>
                        </Table>
                    </Grid>
                </Grid>
            </LoadingContainer>

            <Divider />
            <FormHelperText error sx={{ p: 2 }}>
                {error?.message ? error?.message : null}
            </FormHelperText>
            </td>
            </tr>
        </table>
    );
}

export default RHFGroupIndicator;
